(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = root => {
    root.querySelectorAll('[data-cm-scene]').forEach(scene => {
      if (scene.dataset.ready) return;
      scene.dataset.ready = 'true';
      const set = (x, y) => {
        if (reduce.matches || document.body.dataset.motion === 'off') return;
        scene.style.setProperty('--rx', `${x}deg`);
        scene.style.setProperty('--ry', `${y}deg`);
      };
      scene.addEventListener('pointermove', e => {
        if (e.pointerType !== 'mouse') return;
        const b = scene.getBoundingClientRect();
        set((.5 - (e.clientY - b.top) / b.height) * 13, ((e.clientX - b.left) / b.width - .5) * 20);
      });
      scene.addEventListener('pointerleave', () => set(0, 0));
      scene.querySelectorAll('[data-cm-turn]').forEach(button => button.addEventListener('click', () => set(-5, Number(button.dataset.cmTurn))));
    });
    root.querySelectorAll('[data-cm-filters]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      group.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
        group.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        const cards = group.closest('[data-cm-catalog]').querySelectorAll('[data-cm-category]');
        cards.forEach(card => {
          const hidden = button.dataset.filter !== 'all' && card.dataset.cmCategory !== button.dataset.filter;
          card.hidden = hidden;
          const wrapper = card.closest('[data-cm-card-wrapper]');
          if (wrapper) wrapper.hidden = hidden;
        });
      }));
    });
    root.querySelectorAll('[data-cm-product]').forEach(product => {
      if (product.dataset.ready) return;
      product.dataset.ready = 'true';
      const photo = product.querySelector('[data-cm-main-image]');
      const stage = product.querySelector('[data-cm-product-stage]');
      const displayImage = (url, alt, cutout) => {
        if (!url || !photo) return;
        photo.removeAttribute('srcset');
        photo.src = url;
        if (alt) photo.alt = alt;
        stage.classList.toggle('cm-flat-media', !cutout);
      };
      product.querySelectorAll('[data-cm-thumb]').forEach(button => button.addEventListener('click', () => {
        product.querySelectorAll('[data-cm-thumb]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        displayImage(button.dataset.image, button.dataset.alt, button.dataset.cutout === 'true');
      }));
      const select = product.querySelector('[name="id"]');
      if (select) select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const price = product.querySelector('[data-cm-price]');
        const submit = product.querySelector('[data-cm-add]');
        if (price) price.textContent = option.dataset.price;
        const compare = product.querySelector('[data-cm-compare]');
        const badge = product.querySelector('[data-cm-sale]');
        if (compare) {
          compare.hidden = !option.dataset.compare;
          compare.textContent = option.dataset.compare || '';
        }
        if (badge) {
          badge.hidden = !option.dataset.compare;
          badge.textContent = badge.dataset.saleTemplate.replace('__PERCENT__', option.dataset.saving);
        }
        if (submit) {
          submit.disabled = option.dataset.available !== 'true';
          submit.textContent = submit.disabled ? submit.dataset.sold : submit.dataset.add;
        }
        displayImage(option.dataset.image, option.textContent.trim(), option.dataset.cutout === 'true');
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', nextUrl);
      });
    });
  };
  const start = () => {
    init(document);
    const menu = document.querySelector('[data-cm-menu]');
    const links = document.querySelector('[data-cm-navlinks]');
    if (menu && links) menu.addEventListener('click', () => {
      const open = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(open));
      links.classList.toggle('is-open', open);
    });
    document.querySelectorAll('[data-cm-motion]').forEach(button => button.addEventListener('click', () => {
      const off = document.body.dataset.motion !== 'off';
      document.body.dataset.motion = off ? 'off' : 'on';
      button.setAttribute('aria-pressed', String(off));
      button.textContent = off ? button.dataset.resume : button.dataset.pause;
    }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
